import { SidePanelItem, SidePanelProvider } from './types'

export const SIDE_PANEL_ITEMS: Record<string, SidePanelItem> = {
  HOME: {
    title: 'Home',
    to: 'home',
  },
  LIVESTREAM: {
    title: 'Live TV',
    to: 'livestream',
  },
  SHOWS: {
    title: 'Shows',
    to: 'shows',
  },
  MY_LIST: {
    title: 'My List',
    to: 'my-list',
  },
  MY_STATION: {
    title: 'My Station',
    to: 'my-station',
  },
  SEARCH: {
    title: 'Search',
    to: 'search',
  },
  SETTINGS: {
    title: 'Settings',
    to: 'settings',
  },
}

const allowedItems = Object.keys(SIDE_PANEL_ITEMS).map(
  (key) => SIDE_PANEL_ITEMS[key].to
)

export const isAllowedItem = (item: string): boolean =>
  allowedItems.includes(item)

export const defaultContextValue: SidePanelProvider = {
  closeWithoutVerticalTranslate: false,
  hasFullWidthBackground: false,
  hasMainContentFullHeight: false,
  isSidePanelFocused: true,
  forceSidePanelOpenedUnfocused: false,
  isSidePanelOpened: true,
  activeItem: '',
  isLogoHidden: false,
  setIsSidePanelFocused: () => {},
  setForceSidePanelOpenedUnfocused: () => {},
  setActiveItem: () => {},
  onItemFocus: () => {},
  keepSidePanelOpened: () => {},
  setKeepLogoVisible: () => {},
  focusSidePanel: () => {},
}
